/**
 * 系统配置（localStorage 持久化）
 */
const STORAGE_KEY = 'systemConfig';

/** 默认平台 logo 路径（public 目录下） */
export const DEFAULT_LOGO_URL = '/default-logo.png';

const DEFAULTS = {
  systemTitle: '学途无忧后台管理系统',
  systemTitleShort: '学途无忧网',
  platformLogo: DEFAULT_LOGO_URL
};

export function getSystemConfig() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      systemTitle: typeof parsed.systemTitle === 'string' && parsed.systemTitle.trim()
        ? parsed.systemTitle.trim()
        : DEFAULTS.systemTitle,
      systemTitleShort: typeof parsed.systemTitleShort === 'string' && parsed.systemTitleShort.trim()
        ? parsed.systemTitleShort.trim()
        : DEFAULTS.systemTitleShort,
      platformLogo: typeof parsed.platformLogo === 'string' && parsed.platformLogo.trim()
        ? parsed.platformLogo.trim()
        : DEFAULTS.platformLogo
    };
  } catch (e) {
    return { ...DEFAULTS };
  }
}

export function saveSystemConfig(config) {
  try {
    const merged = { ...DEFAULTS, ...config };
    const toSave = {
      systemTitle: String(merged.systemTitle || DEFAULTS.systemTitle).trim(),
      systemTitleShort: String(merged.systemTitleShort || DEFAULTS.systemTitleShort).trim(),
      platformLogo: String(merged.platformLogo || DEFAULTS.platformLogo).trim()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
    return toSave;
  } catch (e) {
    return getSystemConfig();
  }
}

export { DEFAULTS };
